import {
  FormControlLabel,
  Grid2,
  Popover,
  RadioGroup,
  Typography,
} from "@mui/material";
import { updateFilter } from "store/slices/tableSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import GKRadio from "./GKRadio";

interface Props {
  open: HTMLElement | null;
  setOpen: (el: HTMLElement | null) => void;
  name: string;
}

const SortByPopover = (props: Props) => {
  const { open, setOpen, name } = props;

  const dispatch = useAppDispatch();
  const commonFilter = useAppSelector(
    (state) => state?.table?.commonFilter[name],
  );

  return (
    <Popover
      open={!!open}
      anchorEl={open}
      onClose={() => setOpen(null)}
      slotProps={{
        paper: { sx: { width: "187px", borderRadius: "12px", p: "16px 12px" } },
      }}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
    >
      <Grid2 container spacing={2}>
        <Grid2 size={12}>
          <Typography fontSize={12} fontWeight={600} color=" #697586">
            Sort by
          </Typography>
        </Grid2>
        <Grid2 size={12}>
          <RadioGroup
            value={commonFilter?.sortBy}
            onChange={(e) =>
              dispatch(
                updateFilter({ name, filter: { sortBy: e.target.value } }),
              )
            }
          >
            <FormControlLabel
              label="Amount (₹)"
              value="amount"
              control={<GKRadio disableLeftPadding />}
              sx={{ fontSize: 12, fontWeight: 500, color: " #121926" }}
            />
            <FormControlLabel
              label="Percentage (%)"
              value="percentage"
              control={<GKRadio disableLeftPadding />}
              sx={{ fontSize: 12, fontWeight: 500, color: " #121926" }}
            />
          </RadioGroup>
        </Grid2>
      </Grid2>
    </Popover>
  );
};

export default SortByPopover;
